export const MaskPhone = '00-00-00-00-00';
